/** Nested forms render through portals. Ignore the review modal below this detail. */
export function hasForegroundOrderForm() {
  const root = document.querySelector('.order-detail-modal')?.closest('.ant-modal-wrap')
  if (!root) return false
  const wraps = [...document.querySelectorAll<HTMLElement>('.ant-modal-wrap')].filter(wrap => wrap.getClientRects().length > 0 && getComputedStyle(wrap).display !== 'none')
  const rootIndex = wraps.indexOf(root as HTMLElement)
  const z = Number(getComputedStyle(root).zIndex) || 1000
  return wraps.some((wrap, index) => wrap !== root && ((Number(getComputedStyle(wrap).zIndex) || 1000) > z || ((Number(getComputedStyle(wrap).zIndex) || 1000) === z && index > rootIndex)))
}
